/**
 * TopperSelect — footer-accordions.
 * De menukolommen zijn <details open>; zonder JS staan ze dus altijd open.
 * Op mobiel sluit dit script alles behalve de eerste kolom; op desktop
 * worden ze permanent opengezet (CSS verbergt daar de summary-interactie).
 */
class TsFooter extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const menus = [...this.querySelectorAll('[data-tsf-menu]')];
    if (!menus.length) return;

    const mq = window.matchMedia('(min-width: 860px)');
    const apply = () => {
      if (mq.matches) {
        menus.forEach((d) => { d.open = true; });
      } else {
        menus.forEach((d, i) => { d.open = i === 0; });
      }
    };

    apply();
    mq.addEventListener('change', apply, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#abort = null;
  }
}

if (!customElements.get('ts-footer')) {
  customElements.define('ts-footer', TsFooter);
}
